import { getIsApiPending, getQuoteForm } from '../../../selectors/naMotorInsurance/quote';
import { getCarDetailsForm } from '../../../selectors/naMotorInsurance/carDetails';
import { setExpiredAuth } from '../../../actions/naMotorInsurance/quote';
import {
    apiTransitioncarDetailsForm,
    submitCarDetailsDataSuccess,
    submitCarDetailsFailure,
} from '../../../actions/naMotorInsurance/carDetails';
import { getAccessToken } from '../../../selectors/naMotorInsurance/payments';
import axios from 'axios';

export const checkDoubleInsuranceService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitioncarDetailsForm.pending());
            try {
                const resp = await checkDoubleInsurance(store.getState());
                store.dispatch(submitCarDetailsDataSuccess(resp.data), store);
                store.dispatch(apiTransitioncarDetailsForm.success());
            } catch (e) {
                console.error(e.response);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitioncarDetailsForm.failure());
                store.dispatch(submitCarDetailsFailure(e));
            }
        }
    })();
    return next(action);
};

const computePolicyEndDate = (dateString) => {
    let date = new Date(dateString);
    date.setFullYear(date.getFullYear() + 1);
    let incrementedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    return incrementedDate;
};

const checkDoubleInsurancePayload = (state) => {
    const carDetails = getCarDetailsForm(state);
    const coverDetails = getQuoteForm(state);
    const payload = {
        policystartdate: coverDetails.coverStartDate.value,
        policyenddate: computePolicyEndDate(coverDetails?.coverStartDate?.value) || '',
        vehicleregistrationnumber: carDetails.registrationNumber.value,
        chassisnumber: carDetails.chasisNumber.value,
    };

    // Change payload here
    return {
        ...payload,
    };
};

const checkDoubleInsurance = async (state, store) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/double-insurance-check/';
        return await axios.post(url, checkDoubleInsurancePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        // if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
        //     store.dispatch(setExpiredAuth(true));
        // }
        console.error(e);
        throw e;
    }
};
